import { Component, OnInit } from '@angular/core';

declare const $: any;
declare interface RouteInfo {
    path: string;
    title: string;
    icon: string;
    class: string;
}
export const ROUTES: RouteInfo[] = [
  { path: '/dashboard', title: 'Dashboard',  icon: 'dashboard', class: '' },
    { path: '/clients', title: 'Clients',  icon: 'people', class: '' },
    { path: '/cases', title: 'Cases', icon: 'gavel', class: '' },
    { path: '/diaries', title: 'Diaries', icon: 'book', class: '' },
    { path: '/calendar', title: 'Calendar', icon: 'event', class: '' },
    { path: '/districts', title: 'Districts', icon: 'location_city', class: '' },
    { path: '/court-types', title: 'Court Types', icon: 'account_balance', class: '' },
    { path: '/case-types', title: 'Case Types', icon: 'folder', class: '' },
    { path: '/todos', title: 'Todo', icon: 'assignment', class: '' },
    { path: '/expenses', title: 'Expenses', icon: 'receipt', class: '' },
    { path: '/transactions', title: 'Transactions', icon: 'account_balance_wallet', class: '' },
    
  //   { path: '/user-profile', title: 'User Profile',  icon:'person', class: '' },
  //   { path: '/table-list', title: 'Table List',  icon:'content_paste', class: '' },
  //   { path: '/typography', title: 'Typography',  icon:'library_books', class: '' },
  //   { path: '/icons', title: 'Icons',  icon:'bubble_chart', class: '' },
  //   { path: '/maps', title: 'Maps',  icon:'location_on', class: '' },
  //   { path: '/notifications', title: 'Notifications',  icon:'notifications', class: '' },
  //  { path: '/upgrade', title: 'Upgrade to PRO',  icon:'unarchive', class: 'active-pro' },
];

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css'],
  standalone: false
})
export class SidebarComponent implements OnInit {
  menuItems: any[] | undefined;

  constructor() { }

  ngOnInit() {
    this.menuItems = ROUTES.filter(menuItem => menuItem);
  }
  isMobileMenu() {
      if ($(window).width() > 991) {
          return false;
      }
      return true;
  };
}
